import React from 'react'
import ShadowCard from '../../cards/ShadowCard'
import AdvantageImage from '../../../assets/images/eulerity-art/Advantage.png'

const Advantage = () => {
    const cardData = [
        {
            header: 'AI-Powered Precision',
            text: 'Elevate your marketing with smarter ad spending across all channels.'
        },
        {
            header: 'Data Sovereignty',
            text: 'Command your marketing performance data with full visibility.'
        },
        {
            header: 'Market Agility',
            text: 'Adapt quickly with real-time campaign updates.'
        },
        {
            header: 'Cost Savings',
            text: 'Enjoy a clear ROI without hidden costs.'
        },
        {
            header: 'Comprehensive Visibility',
            text: 'Get both the macro and micro view of your marketing efforts.'
        }
    ]

    return (
        <section className='bg-black py-32 px-8 sm:px-[58px] md:px-[68px] lg:px-[90px] xl:px-32'>
            <div className='flex flex-col gap-14 lg:gap-24'>
                <div className='text-white text-center xl:text-start'>
                    <p className='headerText2 mb-4 lg:mb-5'>The Eulerity Advantage</p>
                    <p className='bodyText2'>It's not just about doing things differently; it's about doing things better. With Eulerity, step away from high costs and static strategies to a platform where efficiency, agility, and growth converge — all powered by marketing automation at scale, perfect for multi-unit location-based businesses.</p>
                </div>
                <ShadowCard extraStyles='max-w-[1184px] 2xl:m-auto'>
                    <div className='flex flex-col gap-[72px] items-center justify-center desktop:flex-row xl:gap-[44px]'>
                        <div className='flex flex-col gap-14'>
                            {
                                cardData.map((card, idx) => {
                                    return (
                                        <div className='flex gap-5' key={idx}>
                                            <div>
                                                <p className='number-bubble'>{idx + 1}</p>
                                            </div>
                                            <div>
                                                <p className='text-fontSize6-bold mb-2 lg:text-fontSize8-bold'>{card.header}</p>
                                                <p className='bodyText text-brandDarkBlue1'>{card?.text}</p>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className='max-w-[288px] lg:max-w-[510px]'>
                            <img src={AdvantageImage} alt='home' className='w-full h-auto object-cover object-center' />
                        </div>
                    </div>
                </ShadowCard>
            </div>
        </section>
    )
}

export default Advantage